import type { RootState } from "../state";
import { ElMessage } from "element-plus";

export function isAppleLike(): boolean {
  try {
    const ua = navigator.userAgent || "";
    const iOS = /iPhone|iPad|iPod/i.test(ua);
    const iPadOS = /Macintosh/.test(ua) && (navigator as any).maxTouchPoints > 1;
    const safari = /Safari/i.test(ua) && !/Chrome|Chromium|Edge/i.test(ua);
    return iOS || iPadOS || safari;
  } catch { return false; }
}

/**
 * iOS 专用：在新产品真正开始播读或确认无旧条后，显示“产品切换成功”
 * - playingProductId：当已知当前起播条目的产品ID时传入（优先）；
 * - 否则回退扫描队列，确认无旧条再提示。
 */
export function showIOSSwitchSuccessIfNeeded(
  this: RootState & { [key: string]: any },
  roomId: string,
  playingProductId?: string | null,
  playingAudioId?: string | null
) {
  if (!isAppleLike()) return;
  if (!roomId || !this.roomStates.has(roomId)) return;
  const state = this.roomStates.get(roomId);
  if (!state) return;

  // 仅当存在“待显示”标记时触发
  if (!(state as any).pendingSwitchSuccessMessage) return;

  // 条件：当前起播条目的产品正是目标/已选产品 → 才提示
  try {
    const pidNow = state.switchingProductId || state.selectedProductId || null;
    const currentIdx = typeof state.currentIndex === "number" ? state.currentIndex : -1;
    const queueItem = currentIdx >= 0 ? state.queue?.[currentIdx] : null;
    const resolvedPlayingPid = playingProductId || (queueItem && queueItem.productId) || null;

    if (resolvedPlayingPid && pidNow && resolvedPlayingPid === pidNow) {
      try {
        console.log(
          `[ios-switch-toast] 播放进度确认，新产品播读中 pid=${resolvedPlayingPid}, audio=${playingAudioId || queueItem?.id || "NA"}`
        );
      } catch {}
      ElMessage.success("产品切换成功");
      delete (state as any).pendingSwitchSuccessMessage;
      try { (state as any).__iosSwitchToastLastAudioId = playingAudioId || queueItem?.id || null; } catch {}
      try {
        if (pidNow) {
          if (!state.cardLoadingMap) state.cardLoadingMap = {} as any;
          state.cardLoadingMap[pidNow] = false;
          if (this.currentRoomState && this.currentRoomState.cardLoadingMap) {
            this.currentRoomState.cardLoadingMap[pidNow] = false;
          }
          if (typeof setIOSSwitchLoading === "function") {
            setIOSSwitchLoading.call(this, pidNow, false);
          }
        }
      } catch {}
      return;
    }
  } catch {}

  // 严格策略：如果没有明确的“当前起播产品ID”，不显示（等待下一次起播时机）
}

/** iOS 专用：统一控制产品卡片的切换 loading 状态（不影响非 iOS） */
export function setIOSSwitchLoading(
  this: RootState & { [key: string]: any },
  productId: string,
  loading: boolean
) {
  if (!isAppleLike()) return;
  if (!this.currentRoomState) return;
  try {
    const state = this.currentRoomState;
    if (!state.cardLoadingMap) state.cardLoadingMap = {} as any;
    state.cardLoadingMap[productId] = !!loading;
  } catch {}
}
